import React from 'react';
import PropTypes from 'prop-types';

import Button from "../Global/Buttons/Button";
import ModalBody from "../Global/Modals/ModalBody";
import ModalContainer from '../Global/Modals/ModalContainer';
import ModalHeader from '../Global/Modals/ModalHeader';
import ModalPadding from "../Global/Modals/ModalPadding";
import ShareFolderList from "./ShareFolderList";
import TextInput from "../Global/Forms/TextInput";

const ShareFolderModal = ({
  modalIsOpen,
  onCloseClick,
  onSearchChange,
  searchValue,
  folder,
  availableAccessors,
  shareAccessorClick,
  shareAccessorId,
  permissionSelect,
}) => (
  <ModalContainer
    isOpen={modalIsOpen}
    closeModal={onCloseClick}
    label="Share folder modal"
  >
    <ModalHeader title="Share with people" onCloseClick={onCloseClick} />
    <ModalBody>
      <div>
        {(availableAccessors.length > 10 || searchValue) &&
          <ModalPadding>
            <TextInput
              name={`search-accessors`}
              placeholder="Search your teams"
              onChange={onSearchChange}
              value={searchValue}
            />
          </ModalPadding>
        }

        <ShareFolderList
          folder={folder}
          availableAccessors={availableAccessors}
          shareAccessorClick={shareAccessorClick}
          shareAccessorId={shareAccessorId}
          permissionSelect={permissionSelect}
        />

        <div className="share__btn--container">
          <ModalPadding>
            <Button onClick={onCloseClick}>Done</Button>
          </ModalPadding>
        </div>
      </div>
    </ModalBody>
  </ModalContainer>
);

ShareFolderModal.propTypes = {
  modalIsOpen: PropTypes.bool.isRequired,
  onCloseClick: PropTypes.func.isRequired,
  onSearchChange: PropTypes.func.isRequired,
  searchValue: PropTypes.string,
  folder: PropTypes.object,
  availableAccessors: PropTypes.array.isRequired,
  shareAccessorClick: PropTypes.func.isRequired,
  shareAccessorId: PropTypes.number,
  permissionSelect: PropTypes.func.isRequired,
};

export default ShareFolderModal;



// WEBPACK FOOTER //
// ./library/app/components/Folders/ShareFolderModal.js